import { ApiResponse } from "apisauce"

export type GeneralApiProblem =
  /**
   * Times up.
   */
  | { kind: "timeout"; temporary: true, response?: any }
  /**
   * Cannot connect to the server for some reason.
   */
  | { kind: "cannot-connect"; temporary: true, response?: any }
  /**
   * The server experienced a problem. Any 5xx error.
   */
  | { kind: "server", response?: any }
  /**
   * We're not allowed because we haven't identified ourself. This is 401.
   */
  | { kind: "unauthorized", response?: any }
  /**
   * We don't have access to perform that request. This is 403.
   */
  | { kind: "forbidden", response?: any }
  /**
   * Unable to find that resource.  This is a 404.
   */
  | { kind: "not-found", response?: any }
  /**
   * All other 4xx series errors.
   */
  | { kind: "rejected", response?: any }
  /**
   * Something truly unexpected happened. Most likely can try again. This is a catch all.
   */
  | { kind: "unknown"; temporary: true, response?: any }
  /**
   * The data we received is not in the expected format.
   */
  | { kind: "bad-data", response?: any }

/**
 * Attempts to get a common cause of problems from an api response.
 *
 * @param response The api response.
 */
export function getGeneralApiProblem(response: ApiResponse<any>): GeneralApiProblem {
  switch (response.problem) {
    case "CONNECTION_ERROR":
      return { kind: "cannot-connect", temporary: true, response }
    case "NETWORK_ERROR":
      return { kind: "cannot-connect", temporary: true, response }
    case "CANCEL_ERROR":
    case "TIMEOUT_ERROR":
      return { kind: "timeout", temporary: true, response }
    case "SERVER_ERROR":
      return { kind: "server", response }
    case "UNKNOWN_ERROR":
      return { kind: "unknown", temporary: true, response }
    case "CLIENT_ERROR":
      switch (response.status) {
        case 401:
          return { kind: "unauthorized", response }
        case 403:
          return { kind: "forbidden", response }
        case 404:
          return { kind: "not-found", response }
        default:
          return { kind: "rejected", response }
      }
    // case "CANCEL_ERROR":
    //   return null
  }

  return null
}
